import styled from 'styled-components/macro';
import { Box } from '@bighealth/react-limbix-ui';

const Logo = styled.img`
  margin-bottom: 32px;
  width: 199px;
`;

const BottomText = styled(Box)`
  position: absolute;
  bottom: 16px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  a {
    color: inherit;
    text-decoration: underline;
    font-weight: 600;
  }
`;

export default {
  Logo,
  BottomText,
};
